import React from "react";

const SortableButton = ({ field, label, sortField, sortOrder, onSort }) => {
  // console.log("SortableButton", field, label, sortField, sortOrder);
  const handleSort = () => {
    const newOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";
    onSort(field, newOrder);
  };

  return (
    <button
      onClick={handleSort}
      style={{
        backgroundColor: "transparent",
        color: "#FFFFFF",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "5px",
        border: "none",
        cursor: "pointer",
      }}
    >
      {label}
      <div style={{ fontSize: "10px" }}>
        {sortField === field ? (sortOrder === "asc" ? "▲" : "▼") : ""}
      </div>
    </button>
  );
};

export default SortableButton;
